export default function MyProfile() {
  return (
    <div>
      <h1>My Profile</h1>
    </div>
  );
}
